export default __webpack_public_path__ + "src/images/packages/kosi-forest-lodge/87006d7898eba4a5df8fae502a7a9ca2-1.jpg";